class ExtraProduct extends HTMLElement {
  constructor() {
    super();
    /** @type {HTMLInputElement|null} */
    this.qtyInput = null;
    /** @type {HTMLElement|null} */
    this.qtyValue = null;
    /** @type {HTMLButtonElement[]} */
    this.qtyBtns = [];
    /** @type {HTMLButtonElement|null} */
    this.addBtn = null;
    /** @type {HTMLElement|null} */
    this.qtyWrap = null;
    /** @type {HTMLElement|null} */
    this.priceEl = null;
    this.basePrice = 0;
    /** @type {HTMLElement|null} */
    this.resultsEl = null;
    /** @type {string} */
    this.productId = '';
    /** @type {string} */
    this.productTitle = '';
    /** @type {string} */
    this.productImage = '';
    /** @type {number} */
    this.birthstoneTotal = 3;
  }

  connectedCallback() {
    this.qtyInput = this.querySelector('.js-qty-input');
    this.qtyValue = this.querySelector('.js-qty-value');
    this.qtyBtns = Array.from(this.querySelectorAll('.js-qty-btn'));
    this.addBtn = this.querySelector('.js-add-btn');
    this.qtyWrap = this.querySelector('.extra-meaning-birthstone__product-qty-wrap');
    this.priceEl = this.querySelector('.js-price');
    const extraNew = this.closest('extra-new');
    this.resultsEl = extraNew?.querySelector('.js-extra-new-results') || null;
    this.birthstoneCountEl = extraNew?.querySelector('.js-extra-birthstone-count') || null;
    this.birthstoneTotal = parseInt(extraNew?.dataset.birthstoneTotal || '', 10) || 3;

    // Get product information
    this._getProductInfo();

    if (this.priceEl && this.priceEl instanceof HTMLElement && this.priceEl.dataset && typeof this.priceEl.dataset.price === 'string') {
      this.basePrice = parseInt(this.priceEl.dataset.price, 10) || 0;
      this._updatePrice(false);
    }
    this._bindEvents();
    this._updateAddBtnState();
    this._updateButtonText();
  }

  _getProductInfo() {
    // Get product title
    const titleEl = this.querySelector('.extra-meaning-birthstone__product-title');
    if (titleEl) {
      this.productTitle = `${titleEl.textContent}`.trim();
    }

    // Get product image
    const imageEl = this.querySelector('.extra-meaning-birthstone__product-image');
    if (imageEl && imageEl instanceof HTMLImageElement) {
      this.productImage = imageEl.src;
    }

    // Get variant ID from add button
    if (this.addBtn && this.addBtn.dataset.variantId) {
      this.productId = this.addBtn.dataset.variantId;
    }
  }

  _bindEvents() {
    if (this.addBtn) {
      this.addBtn.addEventListener('click', () => this._onAddClick());
      this.addEventListener('click', (e) => {
        if (!(e.target instanceof HTMLElement)) return;
        const hasButtonDisabled = this.qtyBtns.some(btn => btn.disabled);
        if (e.target.tagName === 'A' || e.target.tagName === 'BUTTON' || hasButtonDisabled) return;
        this._onAddClick();
      });
    }
    if (this.qtyBtns.length) {
      this.qtyBtns.forEach(btn => {
        btn.addEventListener('click', (e) => this._onQtyBtnClick(e));
      });
    }

    // Stop infinite animation when user scrolls
    const scrollContainer = this.closest('extra-new')?.querySelector('.extra-meaning-birthstone__products-row');

    if (scrollContainer) {
      scrollContainer.addEventListener('scroll', () => {
        scrollContainer.classList.remove('scroll-hint-infinite');
      });
    }
  }

  _onAddClick() {
    // if (this.classList.contains('active')) {
    //   this.classList.remove('active');
    //   if (this.qtyInput) this.qtyInput.value = '1';
    //   if (this.qtyValue) this.qtyValue.textContent = '1';
    //   this._updatePrice();
    //   this._updateAllAddBtnStates();
    //   return;
    // }
    // Remove 'active' from siblings
    // const siblings = this.parentElement ? this.parentElement.querySelectorAll('extra-product.active') : [];
    // siblings.forEach(el => {
    //   if (el !== this) el.classList.remove('active');
    // });
    this.classList.add('active');
    if (this.qtyInput) this.qtyInput.value = '1';
    if (this.qtyValue) this.qtyValue.textContent = '1';
    this._updatePrice();
    this._updateAllAddBtnStates();
    this._updateResults();
    // Notify parent for validation
    const parentPersonalizer = this.closest('custom-personalizer');
    if (parentPersonalizer) {
      const event = new CustomEvent('extraProductToggled', { bubbles: true });
      parentPersonalizer.dispatchEvent(event);
    }
  }

  _onQtyBtnClick(e) {
    if (!this.classList.contains('active')) return;
    const btn = e.currentTarget;
    if (!(btn instanceof HTMLElement) || !btn.dataset.step) return;
    const step = parseInt(btn.dataset.step, 10) || 0;
    if (!this.qtyInput) return;
    let qty = parseInt(this.qtyInput.value, 10) || 1;
    // Calculate the total quantity across all products except this one
    const products = this.parentElement ? this.parentElement.querySelectorAll('extra-product.active') : [];
    let otherTotal = 0;
    products.forEach(el => {
      if (!(el instanceof ExtraProduct)) return;
      if (el !== this && el.qtyInput) otherTotal += parseInt(el.qtyInput.value, 10) || 0;
    });
    qty += step;
    if (qty < 1) {
      // Remove active class and reset to 1
      this.classList.remove('active');
      this.qtyInput.value = String(qty);
      if (this.qtyValue) this.qtyValue.textContent = String(qty);
      this._updatePrice();
      this._updateAllAddBtnStates();
      this._updateResults();
      return;
    }
    if (qty > this.birthstoneTotal) qty = this.birthstoneTotal;
    // Don't allow this product's qty to push total over the limit
    if (qty + otherTotal > this.birthstoneTotal) qty = Math.max(1, this.birthstoneTotal - otherTotal);
    this.qtyInput.value = String(qty);
    if (this.qtyValue) this.qtyValue.textContent = String(qty);
    this._updatePrice();
    this._updateAllAddBtnStates();
    this._updateResults();
  }

  _updateResults() {
    if (!this.resultsEl) return;

    const qty = this.qtyInput ? parseInt(this.qtyInput.value, 10) || 0 : 0;
    const isActive = this.classList.contains('active');

    if (isActive && qty > 0) {
      this._addToResults(qty);
    } else {
      this._removeFromResults();
    }
    if (this.birthstoneCountEl) {
      this.birthstoneCountEl.textContent = String(this._getTotalQty());
    }

    // Update button text based on results
    this._updateButtonText();
  }

  _addToResults(qty) {
    if (!this.resultsEl || !this.productId) return;

    // Remove existing items for this product
    this._removeFromResults();

    // Add new items based on quantity
    for (let i = 0; i < qty; i++) {
      const itemEl = this._createResultItem();
      this.resultsEl.appendChild(itemEl);
    }
  }

  _removeFromResults() {
    if (!this.resultsEl || !this.productId) return;

    // Remove all items for this product
    const existingItems = this.resultsEl.querySelectorAll(`[data-product-id="${this.productId}"]`);
    existingItems.forEach(item => item.remove());
  }

  _createResultItem() {
    const itemEl = document.createElement('div');
    itemEl.className = 'extra-new__result-item';
    itemEl.dataset.productId = this.productId;

    itemEl.innerHTML = `
      <div class="extra-new__result-item-content">
        <button type="button" class="extra-new__result-item-remove" aria-label="Remove item">
          <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
            <path d="M0.579979 8.10678C0.271818 7.77631 0.289897 7.25861 0.620359 6.95044L7.20226 0.81271C7.53272 0.504549 8.05043 0.522627 8.35859 0.85309C8.66675 1.18355 8.64868 1.70126 8.31821 2.00942L1.73631 8.14716C1.40585 8.45532 0.88814 8.43724 0.579979 8.10678Z" fill="#3D3D3D"/>
            <path d="M8.09614 8.36925C7.76568 8.67741 7.24797 8.65933 6.93981 8.32887L0.802085 1.74696C0.493924 1.41649 0.512002 0.898786 0.842465 0.590625C1.17293 0.282463 1.69063 0.300542 1.99879 0.631004L8.13652 7.21292C8.44468 7.54338 8.4266 8.06109 8.09614 8.36925Z" fill="#3D3D3D"/>
          </svg>
        </button>
        <div class="extra-new__result-item-image">
          <img src="${this.productImage}" alt="${this.productTitle}" width="40" height="40">
        </div>
        <div class="extra-new__result-item-title">${this.productTitle}</div>
      </div>
    `;

    itemEl.addEventListener('click', () => this._onRemoveItemClick());

    return itemEl;
  }

  _onRemoveItemClick() {
    // Decrease quantity by 1
    if (!this.qtyInput) return;
    let qty = parseInt(this.qtyInput.value, 10) || 1;
    qty = Math.max(0, qty - 1);

    if (qty === 0) {
      // Remove active class if quantity becomes 0
      this.classList.remove('active');
    }

    this.qtyInput.value = String(qty);
    if (this.qtyValue) this.qtyValue.textContent = String(qty);
    this._updatePrice();
    this._updateAllAddBtnStates();
    this._updateResults();
  }

  _updateButtonText() {
    if (!this.resultsEl) return;

    // Find the button with class js-button-atc
    const parentPersonalizer = this.closest('custom-personalizer');
    if (!parentPersonalizer) return;
    const buttonAtc = parentPersonalizer.querySelector('.js-button-atc');
    if (!buttonAtc) return;

    const buttonTextEl = buttonAtc.querySelector('.js-button-text');
    if (!buttonTextEl) return;

    // Check if results container has any items
    const hasItems = this.resultsEl.children.length > 0;

    // Update button text based on whether results are empty or have items
    if (hasItems) {
      // Show "Add to cart" text when there are items
      const textData = buttonTextEl instanceof HTMLElement ? buttonTextEl.dataset.text : null;
      if (textData) {
        buttonTextEl.textContent = textData;
      }
    } else {
      // Show "Skip extras & Add to cart" text when no items
      const skipTextData = buttonTextEl instanceof HTMLElement ? buttonTextEl.dataset.textSkip : null;
      if (skipTextData) {
        buttonTextEl.textContent = skipTextData;
      }
    }
  }

  _updatePrice(hasUpdatePrice = true) {
    if (!this.priceEl) return;
    let qty = 1;
    if (this.qtyInput) {
      qty = parseInt(this.qtyInput.value, 10) || 0;
    }
    const total = this.basePrice * qty;

    this.priceEl.textContent = total > 0 ? '+' + this._formatMoney(total) : '';
    if (!hasUpdatePrice) return;
    // Trigger event for parent custom-personalizer
    const parentPersonalizer = this.closest('custom-personalizer');
    if (parentPersonalizer) {
      const event = new CustomEvent('extraProductPriceChanged', {
        bubbles: true,
        detail: { price: total }
      });
      parentPersonalizer.dispatchEvent(event);
    }
  }

  _formatMoney(cents, formatString = Shopify.money_format) {
    if (typeof cents == "string") {
      cents = cents.replace(".", "");
    }
    let value = "";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function defaultOption(opt, def) {
      return typeof opt == "undefined" ? def : opt;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ",");
      decimal = defaultOption(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100.0).toFixed(precision);
      const parts = number.split("."),
        dollars = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        ),
        cents = parts[1] ? decimal + parts[1] : "";
      return dollars + cents;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }

  _getTotalQty(excludeEl = null, overrideQty = null) {
    // Sum all active extra-product quantities, optionally excluding one or overriding its value
    let total = 0;
    const products = this.parentElement ? this.parentElement.querySelectorAll('extra-product.active') : [];
    products.forEach(el => {
      if (!(el instanceof ExtraProduct)) return;
      if (excludeEl && el === excludeEl && overrideQty !== null) {
        total += overrideQty;
      } else {
        const input = el.qtyInput;
        if (input) total += parseInt(input.value, 10) || 0;
      }
    });
    return total;
  }

  _updateAddBtnState() {
    // Disable add button when the birthstone cap is reached
    const totalQty = this._getTotalQty();

    if (this.addBtn) {
      this.addBtn.disabled = totalQty >= this.birthstoneTotal && !this.classList.contains('active');
    }
    // Disable qty increment when the birthstone cap is reached
    if (this.qtyBtns.length) {
      this.qtyBtns.forEach(btn => {
        if (btn.dataset.step === '1') {
          btn.disabled = this._getTotalQty() >= this.birthstoneTotal;
        } else {
          btn.disabled = false;
        }
      });
    }
  }

  _updateAllAddBtnStates() {
    // Update all add buttons in the row
    const products = this.parentElement ? this.parentElement.querySelectorAll('extra-product') : [];
    products.forEach(el => {
      if (el instanceof ExtraProduct) el._updateAddBtnState();
    });
  }
}

customElements.define('extra-product', ExtraProduct);
